export default {"src":"/_next/static/media/location-icon.19dd0fb7.svg","height":512,"width":512};